const Footer = () => {
  return (
    <footer className="w-full py-3 sm:py-4 bg-gray-300 text-gray-900 text-xs sm:text-sm flex justify-center items-center text-center px-2 sm:px-4">
      <span className="leading-snug">
        © {new Date().getFullYear()} Billion Deals@Xenford. All rights reserved.
      </span>
    </footer>
  );
};

export default Footer;
